import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

import * as Colors from "../Colors";
import { sortData } from "./ChartHelper";

import "./Chart.css";

export default function StackedBar({ data, options }) {
  data = data ? data : [];
  data = sortData(data, options);

  const yLabel = options.yLabel ?? "Percentage of Responses";
  const colors =
    options.dataLabel.length > 4
      ? Colors.COLOR_MAP[options.dataLabel.length]
      : Colors.COLORS_4;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 30, right: 10, left: 5, bottom: 30 }}
      >
        <Tooltip formatter={(value) => value + "%"} />
        <Legend
          verticalAlign="top"
          align="center"
          wrapperStyle={{
            paddingBottom: 15,
          }}
          iconType="square"
        />
        {options.dataLabel.map((label, i) => {
          return (
            <Bar
              key={i}
              dataKey={"value" + i}
              stackId="a"
              name={label}
              fill={colors[i % colors.length]}
            />
          );
        })}
        <XAxis
          type="category"
          dataKey="name"
          tickLine={false}
          label={{
            value: options.xLabel,
            fill: Colors.PURPLE,
            position: "insideBottom",
            offset: -15,
          }}
          tick
          stroke={Colors.PURPLE}
          width={100}
        />
        <YAxis
          type="number"
          label={{
            value: yLabel,
            angle: -90,
            fill: Colors.PURPLE,
            position: "center",
            dx: -10,
          }}
          stroke={Colors.PURPLE}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
